import styles from "./hub-table-cartao.module.scss";

/**
 * Classes do cartão das listagens completas, para as props do `HubTable`: `className` e `classNames` da raiz, `className`
 * e `pt.wrapper` do `DataTable`, e as classes da célula e do botão da lupa de Detalhamento.
 */
export const hubTableCartao = {
  className: styles.root,
  classNames: { card: styles.card, table: styles.tableWrapper, paginator: styles.paginator },
  dataTableClassName: styles.table,
  dataTablePt: { wrapper: { className: styles.tableScroller } },
  actionCellClassName: styles.actionCell,
  actionButtonClassName: styles.actionButton,
};
